import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import { BoilerAdapter } from 'z3k-config';
import { AccordionWithValidation } from 'console/device-settings/z3k/components/material-utils/accordion-with-validation';
import { FlagSelectors } from 'console/device-settings/z3k/components/material-utils/flag-selector';
import { MaterialHelpPopupUncontrolled } from '../material-utils/help-popup';
export const BoilerAdapterLoggedParams = memo(function BoilerAdapterLoggedParams(props) {
    const { boiler_adapter, ...rest } = props;
    const mask = useMemo(() => BoilerAdapter.allParamsMaskForType(boiler_adapter), [boiler_adapter]);
    const bits = useMemo(() => [
        {
            bit: BoilerAdapter.Flags.WATER_TEMPERATURE_LOGGED,
            label: 't° теплоносителя',
            help_id: 'boiler_adapters_logged_parameter_register_fact_temp',
            show: mask.includes(BoilerAdapter.Flags.WATER_TEMPERATURE_LOGGED),
        },
        {
            bit: BoilerAdapter.Flags.DHW_TEMPERATURE_LOGGED,
            label: 't° ГВС',
            help_id: 'boiler_adapters_logged_parameter_register_dhw_temp',
            show: mask.includes(BoilerAdapter.Flags.DHW_TEMPERATURE_LOGGED),
        },
        {
            bit: BoilerAdapter.Flags.RETURN_TEMPERATURE_LOGGED,
            label: 't° обратного потока',
            help_id: 'boiler_adapters_logged_parameter_register_reverse_temp',
            show: mask.includes(BoilerAdapter.Flags.RETURN_TEMPERATURE_LOGGED),
        },
        {
            bit: BoilerAdapter.Flags.OUTSIDE_TEMPERATURE_LOGGED,
            label: 't° вне дома',
            help_id: 'boiler_adapters_logged_parameter_register_outside_temp',
            show: mask.includes(BoilerAdapter.Flags.OUTSIDE_TEMPERATURE_LOGGED),
        },
        {
            bit: BoilerAdapter.Flags.MODULATION_LEVEL_LOGGED,
            label: 'Уровень модуляции',
            help_id: 'boiler_adapters_logged_parameter_register_mod_level',
            show: mask.includes(BoilerAdapter.Flags.MODULATION_LEVEL_LOGGED),
        },
        {
            bit: BoilerAdapter.Flags.WATER_PRESSURE_LOGGED,
            label: 'Давление теплоносителя',
            help_id: 'boiler_adapters_logged_parameter_register_water_pressure',
            show: mask.includes(BoilerAdapter.Flags.WATER_PRESSURE_LOGGED),
        },
        {
            bit: BoilerAdapter.Flags.DHW_FLOW_RATE_LOGGED,
            label: 'Скорость потока ГВС',
            help_id: 'boiler_adapters_logged_parameter_register_dhw_speed',
            show: mask.includes(BoilerAdapter.Flags.DHW_FLOW_RATE_LOGGED),
        },
    ], [mask]);
    return (_jsx(Box, { width: "100%", children: _jsx(AccordionWithValidation, { header: _jsxs(Typography, { children: ["\u041E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0442\u044C \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B", _jsx(MaterialHelpPopupUncontrolled, { help_id: 'monitored_parameters_adapter_boiler' })] }), validation_result: null, validation_warnings_result: null, children: _jsx(FlagSelectors, { ...rest, bits: bits }) }) }));
});
